import { EventIconAndTime } from "@components/StatsConsole/Widgets/OverviewWidget/parts/EventIconAndTime";
import { MatchPlayerNameAndScore  } from "@components/StatsConsole/Widgets/OverviewWidget/parts/MatchPlayerNameAndScore";
import { IMatchGoalPenaltiesProps } from "@components/StatsConsole/Widgets/OverviewWidget/parts/interfaces";

const MatchEventPenaltiesAway = ({ home_score, away_score, goalscorer, event_type }: IMatchGoalPenaltiesProps) => {
    return (
        <div 
            data-testid="overview-penalty-away"
            className='flex justify-end mx-[16px] mb-[8px] min-h-[34px] max-h-[34px] '>
            <MatchPlayerNameAndScore 
                ml="0px" 
                mr="8px" 
                startPosition='end' 
                event_type={event_type} 
                player={goalscorer} 
                homeScore={home_score}
                awayScore={away_score}
                isHomeGoal={false}
            />
            <EventIconAndTime iconName={event_type} time={null} />

        </div>
    )
}

export default MatchEventPenaltiesAway;


